"use client";
import { r as e, t } from "./registration-BkPgmtZ2.js";
//#region src/openers/retailBox/tokens.ts
var n = {
	box: { role: "accent" },
	stripe: { role: "accentForeground" },
	tissue: { color: "#f3efe6" },
	spotlight: { color: "#fff4e0" }
}, r = t(() => import("./RetailBoxOpener-Okn44rID.js"), n);
function i() {
	e("retail_box", r);
}
//#endregion
export { r as n, n as r, i as t };

//# sourceMappingURL=retailBox-VFadGbgZ.js.map